/**
 * Pied de page
 * Contient des liens
 */

import React from "react";
import { Link } from "@reach/router";
import { openCookiePopup } from "@components/CookieConsent";
import { useUrl } from "@utils/navigation";
import { useI18n } from "../../I18nextProvider";

const Footer = () => {
  const i18n = useI18n();

  const partenairesUrl = useUrl({ type: "partenaires" });

  return (
    <footer className="footer-ms">
      <div>
        <ul>
          <li>
            <Link to={partenairesUrl}>
              <span className="titre">{i18n.t("credits.title")}</span>
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
